// import React , { useState } from 'react';
// import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap';
// import Breadcrumb from 'Common/BreadCrumb';
// import CountUp from "react-countup";
// import ListViewTable from './listViewTable';
// import Flatpickr from "react-flatpickr";

// const OrdersListView = () => {

//     document.title = "List View - Orders | Toner eCommerce + Admin React Template";

//     const [modal_AddOrderModals, setmodal_AddOrderModals] = useState<boolean>(false);
//     function tog_AddOrderModals() {
//         setmodal_AddOrderModals(!modal_AddOrderModals);
//     }

//     return (
//         <React.Fragment>
//             <div className="page-content">
//                 <Container fluid={true}>
//                     <Breadcrumb title="List View" pageTitle="Orders" />
//                     <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-md-2 row-cols-1">
//                         <Col>
//                             <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                                     <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
//                                         // Xmlns:Xlink="http://www.w3.org/1999/xlink"
//                                         width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
//                                         <g mask="url(&quot;#SvgjsMask1530&quot;)" fill="none">
//                                             <path d="M209 112L130 191" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M324 10L149 185" strokeWidth="8" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M333 35L508 -140" strokeWidth="10" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M282 58L131 209" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M290 16L410 -104" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M216 186L328 74" strokeWidth="6" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M255 53L176 132" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M339 191L519 11" strokeWidth="8" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M95 151L185 61" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M249 16L342 -77" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M129 230L286 73" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M80 216L3 293" strokeWidth="6" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
//                                         </g>
//                                         <defs>
//                                             <mask id="SvgjsMask1530">
//                                                 <rect width="400" height="250" fill="#ffffff"></rect>
//                                             </mask>
//                                             <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1531">
//                                                 <stop stopColor="rgba(var(--tb-primary-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-primary-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                             <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1532">
//                                                 <stop stopColor="rgba(var(--tb-primary-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-primary-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <Card.Body className="p-4 z-1 position-relative">
//                                     <div className="d-flex align-items-center gap-3">
//                                         <div className="flex-shrink-0 avatar-sm">
//                                             <div className="avatar-title bg-primary-subtle text-primary fs-3 rounded">
//                                                 <i className="ph-anchor-simple"></i>
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="fs-22 fw-semibold mb-1">
//                                                 <CountUp start={0} end={200.32} duration={3} decimals={2} suffix="k" />
//                                             </h4>
//                                             <p className="mb-0 fw-medium text-uppercase fs-14">New Orders</p>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                         <Col>
//                             <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                                     <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
//                                         // Xmlns:Xlink="http://www.w3.org/1999/xlink"
//                                         width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
//                                         <g mask="url(&quot;#SvgjsMask1608&quot;)" fill="none">
//                                             <path d="M390 87L269 208" strokeWidth="10" stroke="url(#SvgjsLinearGradient1609)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M358 175L273 260" strokeWidth="8" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M319 84L189 214" strokeWidth="10" stroke="url(#SvgjsLinearGradient1609)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M327 218L216 329" strokeWidth="8" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M126 188L8 306" strokeWidth="8" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M220 241L155 306" strokeWidth="10" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M361 92L427 26" strokeWidth="6" stroke="url(#SvgjsLinearGradient1609)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M391 188L275 304" strokeWidth="8" stroke="url(#SvgjsLinearGradient1609)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M178 74L248 4" strokeWidth="10" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M84 52L-56 192" strokeWidth="6" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M183 111L247 47" strokeWidth="10" stroke="url(#SvgjsLinearGradient1610)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M46 8L209 -155" strokeWidth="6" stroke="url(#SvgjsLinearGradient1609)" strokeLinecap="round" className="TopRight"></path>
//                                         </g>
//                                         <defs>
//                                             <mask id="SvgjsMask1608">
//                                                 <rect width="400" height="250" fill="#ffffff"></rect>
//                                             </mask>
//                                             <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1609">
//                                                 <stop stopColor="rgba(var(--tb-warning-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-warning-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                             <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1610">
//                                                 <stop stopColor="rgba(var(--tb-warning-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-warning-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <Card.Body className="p-4 z-1 position-relative">
//                                     <div className="d-flex align-items-center gap-3">
//                                         <div className="flex-shrink-0 avatar-sm">
//                                             <div className="avatar-title bg-warning-subtle text-warning fs-3 rounded">
//                                                 <i className="ph-clock-clockwise"></i>
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="fs-22 fw-semibold mb-1">
//                                                 <CountUp start={0} end={35.21} duration={3} decimals={2} suffix="k" />
//                                             </h4>
//                                             <p className="mb-0 fw-medium text-uppercase fs-14">Pending Orders</p>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                         <Col>
//                             <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                                 <div className="position-absolute end-0 start-0 bottom-0 z-0">
//                                     <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
//                                         // Xmlns:Xlink="http://www.w3.org/1999/xlink"
//                                         width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
//                                         <g mask="url(&quot;#SvgjsMask1561&quot;)" fill="none">
//                                             <path d="M306 65L446 -75" strokeWidth="8" stroke="url(#SvgjsLinearGradient1552)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M399 2L315 86" strokeWidth="10" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M83 77L256 -96" strokeWidth="6" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M281 212L460 33" strokeWidth="6" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M257 62L76 243" strokeWidth="6" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M305 123L214 214" strokeWidth="6" stroke="url(#SvgjsLinearGradient1552)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M327 222L440 109" strokeWidth="6" stroke="url(#SvgjsLinearGradient1552)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M287 109L362 34" strokeWidth="10" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M259 194L332 121" strokeWidth="8" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M376 186L240 322" strokeWidth="8" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M308 153L123 338" strokeWidth="6" stroke="url(#SvgjsLinearGradient1553)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M218 62L285 -5" strokeWidth="8" stroke="url(#SvgjsLinearGradient1552)" strokeLinecap="round" className="BottomLeft"></path>
//                                         </g>
//                                         <defs>
//                                             <mask id="SvgjsMask1561">
//                                                 <rect width="400" height="250" fill="#ffffff"></rect>
//                                             </mask>
//                                             <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1552">
//                                                 <stop stopColor="rgba(var(--tb-success-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-success-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                             <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1553">
//                                                 <stop stopColor="rgba(var(--tb-success-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-success-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <Card.Body className="p-4 z-1 position-relative">
//                                     <div className="d-flex align-items-center gap-3">
//                                         <div className="flex-shrink-0 avatar-sm">
//                                             <div className="avatar-title bg-success-subtle text-success fs-3 rounded">
//                                                 <i className="ph-truck"></i>
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="fs-22 fw-semibold mb-1">
//                                                 <CountUp start={0} end={647.32} duration={3} decimals={2} suffix="k" />
//                                             </h4>
//                                             <p className="mb-0 fw-medium text-uppercase fs-14">Delivered Orders</p>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                         <Col>
//                             <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                                 <div className="position-absolute end-0 start-0 top-0 z-0">
//                                     <svg xmlns="http://www.w3.org/2000/svg" version="1.1"

//                                         // Xmlns:Xlink="http://www.w3.org/1999/xlink"

//                                         width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
//                                         <g mask="url(&quot;#SvgjsMask1571&quot;)" fill="none">
//                                             <path d="M306 65L446 -75" strokeWidth="8" stroke="url(#SvgjsLinearGradient1561)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M399 2L315 86" strokeWidth="10" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M83 77L256 -96" strokeWidth="6" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M281 212L460 33" strokeWidth="6" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M257 62L76 243" strokeWidth="6" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M305 123L214 214" strokeWidth="6" stroke="url(#SvgjsLinearGradient1561)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M327 222L440 109" strokeWidth="6" stroke="url(#SvgjsLinearGradient1561)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M287 109L362 34" strokeWidth="10" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M259 194L332 121" strokeWidth="8" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M376 186L240 322" strokeWidth="8" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M308 153L123 338" strokeWidth="6" stroke="url(#SvgjsLinearGradient1562)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M218 62L285 -5" strokeWidth="8" stroke="url(#SvgjsLinearGradient1561)" strokeLinecap="round" className="BottomLeft"></path>
//                                         </g>
//                                         <defs>
//                                             <mask id="SvgjsMask1571">
//                                                 <rect width="400" height="250" fill="#ffffff"></rect>
//                                             </mask>
//                                             <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1561">
//                                                 <stop stopColor="rgba(var(--tb-secondary-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-secondary-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                             <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1562">
//                                                 <stop stopColor="rgba(var(--tb-secondary-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-secondary-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <Card.Body className="p-4 z-1 position-relative">
//                                     <div className="d-flex align-items-center gap-3">
//                                         <div className="flex-shrink-0 avatar-sm">
//                                             <div className="avatar-title bg-secondary-subtle text-secondary fs-3 rounded">
//                                                 <i className="ph-cube"></i>
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="fs-22 fw-semibold mb-1">
//                                                 <CountUp start={0} end={215.36} duration={3} decimals={2} suffix="k" />
//                                             </h4>
//                                             <p className="mb-0 fw-medium text-uppercase fs-14">Pickups Orders</p>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                         <Col>
//                             <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                                 <div className="position-absolute end-0 start-0 bottom-0 z-0">
//                                     <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
//                                         // Xmlns:Xlink="http://www.w3.org/1999/xlink"
//                                         width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
//                                         <g mask="url(&quot;#SvgjsMask1551&quot;)" fill="none">
//                                             <path d="M306 65L446 -75" strokeWidth="8" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M399 2L315 86" strokeWidth="10" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M83 77L256 -96" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M281 212L460 33" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M257 62L76 243" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M305 123L214 214" strokeWidth="6" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M327 222L440 109" strokeWidth="6" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
//                                             <path d="M287 109L362 34" strokeWidth="10" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M259 194L332 121" strokeWidth="8" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M376 186L240 322" strokeWidth="8" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M308 153L123 338" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
//                                             <path d="M218 62L285 -5" strokeWidth="8" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
//                                         </g>
//                                         <defs>
//                                             <mask id="SvgjsMask1551">
//                                                 <rect width="400" height="250" fill="#ffffff"></rect>
//                                             </mask>
//                                             <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1558">
//                                                 <stop stopColor="rgba(var(--tb-danger-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-danger-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                             <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1559">
//                                                 <stop stopColor="rgba(var(--tb-danger-rgb), 0)" offset="0"></stop>
//                                                 <stop stopColor="rgba(var(--tb-danger-rgb), 0.1)" offset="1"></stop>
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <Card.Body className="p-4 z-1 position-relative">
//                                     <div className="d-flex align-items-center gap-3">
//                                         <div className="flex-shrink-0 avatar-sm">
//                                             <div className="avatar-title bg-danger-subtle text-danger fs-3 rounded">
//                                                 <i className="ph-trash"></i>
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="fs-22 fw-semibold mb-1">
//                                                 <CountUp start={0} end={8649} duration={3} separator="," />
//                                             </h4>
//                                             <p className="mb-0 fw-medium text-uppercase fs-14">Cancelled Orders</p>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                     </Row>

//                     <Row id="orderList">
//                         <Col lg={12}>
//                             <Card>
//                                 <Card.Body>
//                                     <Row className="g-3">
//                                         <Col xxl={4} sm={6}>
//                                             <div className="search-box">
//                                                 <input type="text" className="form-control search" placeholder="Search for order ID, customer, order status or something..." />
//                                                 <i className="ri-search-line search-icon"></i>
//                                             </div>
//                                         </Col>

//                                         <Col xxl={2} sm={6}>
//                                             <div>
//                                                 <Flatpickr
//                                                 className="form-control flatpickr-input"
//                                                 placeholder='Select Date'
//                                                     options={{
//                                                     dateFormat: "d M, Y",
//                                                     }}
//                                                 />
//                                             </div>
//                                         </Col>

//                                         <Col xxl={2} sm={6}>
//                                             <div>
//                                                 <select className="form-select" name="choices-single-default" id="idStatus">
//                                                     <option value="">Status</option>
//                                                     <option value="all" defaultValue="All">All</option>
//                                                     <option value="Pending">Pending</option>
//                                                     <option value="Inprogress">Inprogress</option>
//                                                     <option value="Cancelled">Cancelled</option>
//                                                     <option value="Pickups">Pickups</option>
//                                                     <option value="Returns">Returns</option>
//                                                     <option value="Delivered">Delivered</option>
//                                                 </select>
//                                             </div>
//                                         </Col>

//                                         <Col xxl={2} sm={6}>
//                                             <div>
//                                                 <select className="form-select" name="choices-single-default" id="idPayment">
//                                                     <option value="">Select Payment</option>
//                                                     <option value="all" defaultValue="All">All</option>
//                                                     <option value="Mastercard">Mastercard</option>
//                                                     <option value="Paypal">Paypal</option>
//                                                     <option value="Visa">Visa</option>
//                                                     <option value="COD">COD</option>
//                                                 </select>
//                                             </div>
//                                         </Col>

//                                         <Col xxl={2} sm={12}>
//                                             <div className="hstack gap-2">
//                                                 <Button variant='primary' className="w-100">
//                                                     <i className="bi bi-filter me-1"></i> Filter
//                                                 </Button>
//                                                 <Button variant='success' onClick={() => tog_AddOrderModals()} className="w-100 add-btn" data-bs-toggle="modal" data-bs-target="#showModal">
//                                                     Add Order
//                                                 </Button>
//                                             </div>
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>

//                             {/* ListViewTable */}
//                             <ListViewTable />

//                             <div className="noresult" style={{ display: "none" }}>
//                                 <div className="text-center py-4">
//                                     <div className="avatar-md mx-auto mb-4">
//                                         <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-24">
//                                             <i className="bi bi-search"></i>
//                                         </div>
//                                     </div>
//                                     <h5 className="mt-2">Sorry! No Result Found</h5>
//                                     <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
//                                 </div>
//                             </div>

//                             <Modal show={modal_AddOrderModals} onHide={() => { tog_AddOrderModals(); }} centered>
//                                 <Modal.Header className="px-4 pt-4" closeButton>
//                                     <h5 className="modal-title" id="exampleModalLabel">Add Order</h5>
//                                 </Modal.Header>
//                                 <Form className="tablelist-form" >
//                                     <Modal.Body className="p-4">
//                                         <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
//                                         <input type="hidden" id="id-field"/>
//                                         <div className="mb-3">
//                                             <label htmlFor="customername-field" className="form-label">Customer Name</label>
//                                             <input type="text" id="customername-field" className="form-control" placeholder="Enter name" required/>
//                                         </div>

//                                         <div className="mb-3">
//                                             <label htmlFor="productname-field" className="form-label">Product</label>
//                                             <div>
//                                                 <select className="form-select" id="productname-field" required>
//                                                     <option value="">Product</option>
//                                                     <option value="World's Most Expensive T-Shirt">World's Most Expensive T-Shirt</option>
//                                                     <option value="Ninja Pro Max Smartwatch">Ninja Pro Max Smartwatch</option>
//                                                     <option value="Carven Lounge Chair Red">Carven Lounge Chair Red</option>
//                                                     <option value="American egale outfitters Shirt">American egale outfitters Shirt</option>
//                                                     <option value="Like Style Women Black Handbag">Like Style Women Black Handbag</option>
//                                                     <option value="Funky Prints T-shirt">Funky Prints T-shirt</option>
//                                                     <option value="Innovative Education Book">Innovative Education Book</option>
//                                                     <option value="Leather band Smartwatches">Leather band Smartwatches</option>
//                                                     <option value="Oxford Button-Down Shirt">Oxford Button-Down Shirt</option>
//                                                     <option value="Apple Headphone">Apple Headphone</option>
//                                                     <option value="Borosil Paper Cup">Borosil Paper Cup</option>
//                                                     <option value="Evolve Smartwatch">Evolve Smartwatch</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <Row className="gy-4 mb-3">
//                                             <Col md={6}>
//                                                 <div>
//                                                     <Form.Label htmlFor="createdate-field">Order Date</Form.Label>
//                                                     <Flatpickr
//                                                         className="form-control flatpickr-input"
//                                                         placeholder='Select Date'
//                                                         options={{
//                                                             dateFormat: "d M, Y",
//                                                         }}
//                                                     />
//                                                 </div>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <div>
//                                                     <Form.Label htmlFor="deliverydate-field">Delivery Date</Form.Label>
//                                                     <Flatpickr
//                                                         className="form-control flatpickr-input"
//                                                         placeholder='Select Date'
//                                                         options={{
//                                                             dateFormat: "d M, Y",
//                                                         }}
//                                                     />
//                                                 </div>
//                                             </Col>
//                                         </Row>

//                                         <Row className="gy-4 mb-3">
//                                             <Col md={6}>
//                                                 <div>
//                                                     <Form.Label htmlFor="amount-field">Amount</Form.Label>
//                                                     <Form.Control type="number" id="amount-field" placeholder="Total amount" required/>
//                                                 </div>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <div>
//                                                     <Form.Label htmlFor="payment-field">Payment Method</Form.Label>
//                                                     <div>
//                                                         <select className="form-select"  required id="payment-field">
//                                                             <option value="">Payment Method</option>
//                                                             <option value="Mastercard">Mastercard</option>
//                                                             <option value="Visa">Visa</option>
//                                                             <option value="COD">COD</option>
//                                                             <option value="Paypal">Paypal</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                             </Col>
//                                         </Row>

//                                         <div>
//                                             <Form.Label htmlFor="delivered-status">Delivery Status</Form.Label>
//                                             <div>
//                                                 <select className="form-select" required id="delivered-status">
//                                                     <option value="">Delivery Status</option>
//                                                     <option value="Pending">Pending</option>
//                                                     <option value="Inprogress">Inprogress</option>
//                                                     <option value="Cancelled">Cancelled</option>
//                                                     <option value="Pickups">Pickups</option>
//                                                     <option value="Delivered">Delivered</option>
//                                                     <option value="Returns">Returns</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </Modal.Body>
//                                     <div className="modal-footer">
//                                         <div className="hstack gap-2 justify-content-end">
//                                             <Button className="btn-ghost-danger" onClick={() => { tog_AddOrderModals(); }} >Close</Button>
//                                             <Button variant='success' id="add-btn">Add Order</Button>
//                                         </div>
//                                     </div>
//                                 </Form>
//                             </Modal>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </React.Fragment >
//     );
// }

// export default OrdersListView;

import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Breadcrumb from "Common/BreadCrumb";
import CountUp from "react-countup";
import ListViewTable from "./listViewTable";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { addToCart, fetchOrders, fetchUsers, getAllProducts } from "api/apis";
import { Product, User, Variant } from "interface";
import axiosInstance from "api/auth";
import { toast } from "react-toastify";

const OrdersListView = () => {
  document.title = "List View - Orders";

  const [modal_AddOrderModals, setmodal_AddOrderModals] =
    useState<boolean>(false);
  const [statusCounts, setStatusCounts] = useState({
    notProcessed: 0,
    processing: 0,
    shipped: 0,
    delivered: 0,
    cancelled: 0,
  });
  const [loading, setLoading] = useState(true);

  // Filter states
  const [searchText, setSearchText] = useState("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedPayment, setSelectedPayment] = useState("all");
  const [users, setUsers] = useState<User[]>([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedVariants, setSelectedVariants] = useState<Variant[]>([]);
  const [selectedVariant, setSelectedVariant] = useState<{
    product: Product;
    variant: Variant;
  } | null>(null);
  const [showQuantityModal, setShowQuantityModal] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState<any>(null);
  const [showCartModal, setShowCartModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    paymentMethod: "cash",
    status: "Not processed",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    zipCode: "",
    state: "",
    country: "",
    city: "",
  });
  const [isCartLoading, setIsCartLoading] = useState(false);

  const getAllVariants = (products: Product[]): Variant[] => {
    return products.flatMap(
      (product) =>
        product.variants?.map((variant) => ({
          ...variant,
          productId: product._id,
          productName: product.name,
          productSku: product.sku,
        })) || [] // Return empty array if variants is undefined
    );
  };

  useEffect(() => {
    if (selectedUserId) {
      const selectedUser = users.find((user) => user._id === selectedUserId);
      if (selectedUser) {
        setOrderDetails((prev) => ({
          ...prev,
          firstName: selectedUser.firstName || "",
          lastName: selectedUser.lastName || "",
        }));
      }
    }
  }, [selectedUserId, users]);

  useEffect(() => {
    const fetchCart = async () => {
      if (!selectedUserId) return;

      try {
        const response = await axiosInstance.get(
          `/cart/get?userId=${selectedUserId}`
        );
        if (response.data.success && response.data.cart.length > 0) {
          setCart(response.data.cart[0]); // Assuming we take the first active cart
        } else {
          setCart(null);
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
        setCart(null);
      }
    };

    fetchCart();
  }, [selectedUserId]);

  const handleDeleteFromCart = async (productId: string, variantId: string) => {
    if (!cart) return;

    try {
      setIsCartLoading(true);
      const response = await axiosInstance.delete(
        `/cart/delete/${cart._id}/${productId}/${variantId}`
      );

      if (response.data.success) {
        toast.success("Product removed from cart");
        // Refresh the cart
        const cartResponse = await axiosInstance.get(
          `/cart/get?userId=${selectedUserId}`
        );
        if (cartResponse.data.success) {
          setCart(cartResponse.data.cart[0]);
        } else {
          setCart(null);
        }
      }
    } catch (error) {
      console.error("Error deleting from cart:", error);
      toast.error("Failed to remove product from cart");
    } finally {
      setIsCartLoading(false);
    }
  };

  const handleIncrementQuantity = async (
    productId: string,
    variantId: string
  ) => {
    if (!cart) return;

    try {
      setIsCartLoading(true);
      const response = await axiosInstance.put(
        `/cart/${cart._id}/incrementProductQuantity/${productId}/${variantId}`
      );

      if (response.data.success) {
        toast.success("Quantity increased");
        const cartResponse = await axiosInstance.get(
          `/cart/get?userId=${selectedUserId}`
        );
        if (cartResponse.data.success) {
          setCart(cartResponse.data.cart[0]);
        }
      } else if (
        response.data.message ===
        "Cannot increase quantity beyond available stock"
      ) {
        toast.warning(response.data.message);
      }
    } catch (error) {
      console.error("Error incrementing quantity:", error);
      toast.error("Failed to update quantity");
    } finally {
      setIsCartLoading(false);
    }
  };

  const handleDecreaseQuantity = async (
    productId: string,
    variantId: string
  ) => {
    if (!cart) return;

    try {
      setIsCartLoading(true);
      const response = await axiosInstance.put(
        `/cart/${cart._id}/decreaseProductQuantity/${productId}/${variantId}`
      );

      if (response.data.success) {
        toast.success("Quantity decreased");
        const cartResponse = await axiosInstance.get(
          `/cart/get?userId=${selectedUserId}`
        );
        if (cartResponse.data.success) {
          setCart(cartResponse.data.cart[0]);
        }
      } else if (response.data.message === "Cannot decrement below 1") {
        toast.warning(response.data.message);
      }
    } catch (error) {
      console.error("Error decreasing quantity:", error);
      toast.error("Failed to update quantity");
    } finally {
      setIsCartLoading(false);
    }
  };

  useEffect(() => {
    const getUsers = async () => {
      try {
        const data = await fetchUsers(1, 1000); // large limit to get all users
        setUsers(data.users || []); // adjust based on your actual API shape
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };

    getUsers();
  }, []);

  const handleVariantSelect = async (product: Product, variant: Variant) => {
    setSelectedVariant({ product, variant });
    setQuantity(1); // Reset quantity to 1 when selecting a new variant
    setShowQuantityModal(true);
  };

  const handleAddToCart = async () => {
    if (!selectedVariant || !selectedUserId) {
      alert("please select user and variant both");
      return;
    }

    try {
      const payload = {
        products: [
          {
            product: selectedVariant.product._id,
            variantId: selectedVariant.variant._id,
            quantity: quantity,
          },
        ],
        userId: selectedUserId,
      };

      const response = await addToCart(payload);

      // Refresh the cart after adding
      const cartResponse = await axiosInstance.get(
        `/cart/get?userId=${selectedUserId}`
      );
      if (cartResponse.data.success) {
        setCart(cartResponse.data.cart[0]);
      }

      // setSelectedVariant(null);
      setQuantity(1);
      setShowQuantityModal(false);
    } catch (error) {
      console.error("Failed to add to cart:", error);
    }
  };

  const handleCreateOrder = async () => {
    if (!cart || !selectedUserId) return;

    // Basic validation
    if (!orderDetails.address || !orderDetails.city || !orderDetails.country) {
      alert("Please fill in all required address fields");
      return;
    }

    try {
      const payload = {
        cartId: cart._id,
        total: cart.total,
        paymentMethod: orderDetails.paymentMethod,
        status: orderDetails.status,
        userId: selectedUserId,
        firstName: orderDetails.firstName,
        lastName: orderDetails.lastName,
        phone: orderDetails.phone,
        address: orderDetails.address,
        zipCode: orderDetails.zipCode,
        state: orderDetails.state,
        country: orderDetails.country,
        city: orderDetails.city,
        // Include products with details
        products: cart.products.map((item: any) => ({
          product: item.product._id,
          variantId: item.variant._id,
          quantity: item.quantity,
          price: item.purchasePrice,
          name: item.product.name,
          variantDetails: item.variant,
        })),
      };

      const response = await axiosInstance.post("/order/add", payload);
      console.log("Order created:", response.data);

      // Reset and close modals on success
      setShowCartModal(false);
      setmodal_AddOrderModals(false);
      setCart(null);
      setSelectedUserId("");

      // Show success message
      alert("Order created successfully!");
    } catch (error) {
      console.error("Failed to create order:", error);
      alert("Failed to create order. Please try again.");
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await getAllProducts(1, 1000);
        setProducts(res.products || []);
        console.log("Products with variants: ", res.products);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Function to pass filters to ListViewTable
  const getFilters = () => ({
    searchText,
    selectedDate,
    selectedStatus,
    selectedPayment,
  });

  function tog_AddOrderModals() {
    setmodal_AddOrderModals(!modal_AddOrderModals);
    // Clear selections when modal is closed
    // if (!modal_AddOrderModals) {
    setSelectedUserId("");
    setCart(null);
    setSelectedVariants([]);
    setSelectedVariant(null);
    // }
  }

  useEffect(() => {
    const fetchOrderCounts = async () => {
      try {
        setLoading(true);
        const data = await fetchOrders(1, 1000); // Fetch all orders with a large limit
        console.log("Count: ", data);

        // Initialize counts
        const counts = {
          notProcessed: 0,
          processing: 0,
          shipped: 0,
          delivered: 0,
          cancelled: 0,
        };

        // Loop through orders and their products
        data.orders.forEach((order) => {
          const status = order.status?.trim().toLowerCase();

          switch (status) {
            case "not processed":
              counts.notProcessed++;
              break;
            case "processing":
              counts.processing++;
              break;
            case "shipped":
              counts.shipped++;
              break;
            case "delivered":
              counts.delivered++;
              break;
            case "cancelled":
              counts.cancelled++;
              break;
            default:
              // Unknown status - optionally log or ignore
              break;
          }
        });

        setStatusCounts(counts);
      } catch (error) {
        console.error("Error fetching order counts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderCounts();
  }, []);

  if (loading) {
    return <div className="page-content">Loading...</div>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="List View" pageTitle="Orders" />
          <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-md-2 row-cols-1">
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1530")' fill="none">
                      <path
                        d="M209 112L130 191"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M324 10L149 185"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M333 35L508 -140"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M282 58L131 209"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M290 16L410 -104"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M216 186L328 74"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M255 53L176 132"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M339 191L519 11"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M95 151L185 61"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M249 16L342 -77"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1532)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M129 230L286 73"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M80 216L3 293"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1531)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1530">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1531"
                      >
                        <stop
                          stopColor="rgba(var(--tb-primary-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-primary-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1532"
                      >
                        <stop
                          stopColor="rgba(var(--tb-primary-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-primary-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-primary-subtle text-primary fs-3 rounded">
                        <i className="ph-anchor-simple"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.notProcessed}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Not Processed
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1608")' fill="none">
                      <path
                        d="M390 87L269 208"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M358 175L273 260"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M319 84L189 214"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M327 218L216 329"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M126 188L8 306"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M220 241L155 306"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M361 92L427 26"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M391 188L275 304"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M178 74L248 4"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M84 52L-56 192"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M183 111L247 47"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1610)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M46 8L209 -155"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1609)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1608">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1609"
                      >
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1610"
                      >
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-warning-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-warning-subtle text-warning fs-3 rounded">
                        <i className="ph-clock-clockwise"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.processing}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Processing
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <div className="position-absolute end-0 start-0 bottom-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1561")' fill="none">
                      <path
                        d="M306 65L446 -75"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M399 2L315 86"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M83 77L256 -96"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M281 212L460 33"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M257 62L76 243"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M305 123L214 214"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M327 222L440 109"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M287 109L362 34"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M259 194L332 121"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M376 186L240 322"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M308 153L123 338"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1553)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M218 62L285 -5"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1552)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1561">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1552"
                      >
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1553"
                      >
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-success-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-success-subtle text-success fs-3 rounded">
                        <i className="ph-truck"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.shipped}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Shipped
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <div className="position-absolute end-0 start-0 top-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1571")' fill="none">
                      <path
                        d="M306 65L446 -75"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1561)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M399 2L315 86"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M83 77L256 -96"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M281 212L460 33"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M257 62L76 243"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M305 123L214 214"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1561)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M327 222L440 109"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1561)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M287 109L362 34"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M259 194L332 121"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M376 186L240 322"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M308 153L123 338"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1562)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M218 62L285 -5"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1561)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1571">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1561"
                      >
                        <stop
                          stopColor="rgba(var(--tb-secondary-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-secondary-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1562"
                      >
                        <stop
                          stopColor="rgba(var(--tb-secondary-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-secondary-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-secondary-subtle text-secondary fs-3 rounded">
                        <i className="ph-cube"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.delivered}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Delivered
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <div className="position-absolute end-0 start-0 bottom-0 z-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="400"
                    height="250"
                    preserveAspectRatio="none"
                    viewBox="0 0 400 250"
                  >
                    <g mask='url("#SvgjsMask1551")' fill="none">
                      <path
                        d="M306 65L446 -75"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1558)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M399 2L315 86"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M83 77L256 -96"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M281 212L460 33"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M257 62L76 243"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M305 123L214 214"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1558)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M327 222L440 109"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1558)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                      <path
                        d="M287 109L362 34"
                        strokeWidth="10"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M259 194L332 121"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M376 186L240 322"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M308 153L123 338"
                        strokeWidth="6"
                        stroke="url(#SvgjsLinearGradient1559)"
                        strokeLinecap="round"
                        className="TopRight"
                      ></path>
                      <path
                        d="M218 62L285 -5"
                        strokeWidth="8"
                        stroke="url(#SvgjsLinearGradient1558)"
                        strokeLinecap="round"
                        className="BottomLeft"
                      ></path>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1551">
                        <rect width="400" height="250" fill="#ffffff"></rect>
                      </mask>
                      <linearGradient
                        x1="100%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        id="SvgjsLinearGradient1558"
                      >
                        <stop
                          stopColor="rgba(var(--tb-danger-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-danger-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        x1="0%"
                        y1="100%"
                        x2="100%"
                        y2="0%"
                        id="SvgjsLinearGradient1559"
                      >
                        <stop
                          stopColor="rgba(var(--tb-danger-rgb), 0)"
                          offset="0"
                        ></stop>
                        <stop
                          stopColor="rgba(var(--tb-danger-rgb), 0.1)"
                          offset="1"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-danger-subtle text-danger fs-3 rounded">
                        <i className="ph-trash"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.cancelled}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Cancelled
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Rest of your component remains the same */}
          <Row id="orderList">
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <Row className="g-3">
                    <Col xxl={4} sm={6}>
                      <div className="search-box">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search for order ID, customer, order status or something..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>

                    <Col xxl={2} sm={6}>
                      <div>
                        <Flatpickr
                          className="form-control flatpickr-input"
                          placeholder="Select Date"
                          options={{
                            dateFormat: "d M, Y",
                          }}
                          value={selectedDate || undefined}
                          onChange={(dates) =>
                            setSelectedDate(dates[0] || null)
                          }
                        />
                      </div>
                    </Col>

                    <Col xxl={2} sm={6}>
                      <div>
                        <select
                          className="form-select"
                          name="choices-single-default"
                          id="idStatus"
                          value={selectedStatus}
                          onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                          <option value="all">All Status</option>
                          <option value="Not processed">Not processed</option>
                          <option value="Processing">Processing</option>
                          <option value="Shipped">Shipped</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </div>
                    </Col>

                    <Col xxl={2} sm={6}>
                      <div>
                        <select
                          className="form-select"
                          name="choices-single-default"
                          id="idPayment"
                          value={selectedPayment}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                        >
                          <option value="all">All Payments</option>
                          <option value="Online">Online</option>
                          <option value="COD">COD</option>
                        </select>
                      </div>
                    </Col>

                    <Col xxl={2} sm={12}>
                      <div className="hstack gap-2">
                        <Button
                          variant="primary"
                          className="w-100"
                          onClick={() => {
                            // Reset all filters
                            setSearchText("");
                            setSelectedDate(null);
                            setSelectedStatus("all");
                            setSelectedPayment("all");
                          }}
                        >
                          <i className="bi bi-filter me-1"></i> Reset
                        </Button>
                        <Button
                          variant="success"
                          onClick={() => tog_AddOrderModals()}
                          className="w-100 add-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#showModal"
                        >
                          Add Order
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Pass filters to ListViewTable */}
              <ListViewTable filters={getFilters()} />

              <div className="noresult" style={{ display: "none" }}>
                <div className="text-center py-4">
                  <div className="avatar-md mx-auto mb-4">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-24">
                      <i className="bi bi-search"></i>
                    </div>
                  </div>
                  <h5 className="mt-2">Sorry! No Result Found</h5>
                  <p className="text-muted mb-0">
                    We've searched more than 150+ Orders We did not find any
                    orders for you search.
                  </p>
                </div>
              </div>

              <Modal
                show={modal_AddOrderModals}
                onHide={() => {
                  tog_AddOrderModals();
                }}
                centered
              >
                <Modal.Header className="px-4 pt-4" closeButton>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Add Order
                  </h5>
                </Modal.Header>
                <Form className="tablelist-form">
                  <Modal.Body className="p-4">
                    <div
                      id="alert-error-msg"
                      className="d-none alert alert-danger py-2"
                    ></div>
                    <input type="hidden" id="id-field" />
                    <div className="mb-3">
                      <label
                        htmlFor="customername-field"
                        className="form-label"
                      >
                        Customer
                      </label>
                      <select
                        id="customername-field"
                        className="form-select"
                        required
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                      >
                        <option value="">Select a user</option>
                        {users.map((user) => (
                          <option key={user._id} value={user._id}>
                            {user.firstName} {user.lastName} ({user.email})
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="variantname-field" className="form-label">
                        Variants
                      </label>
                      <Select
                        id="variantname-field"
                        isMulti
                        options={products.flatMap(
                          (product) =>
                            product.variants?.map((variant) => ({
                              value: variant._id,
                              label: `${product.name} - ${variant.sku}`,
                              data: {
                                ...variant,
                                productId: product._id,
                                productName: product.name,
                              },
                            })) || []
                        )}
                        classNamePrefix="select"
                        placeholder="Select variants"
                        onChange={(selectedOptions) => {
                          // For each selected option, show the quantity modal
                          selectedOptions.forEach((option) => {
                            const product = products.find(
                              (p) => p._id === option.data.productId
                            );
                            if (product) {
                              handleVariantSelect(product, option.data);
                            }
                          });
                        }}
                        formatOptionLabel={(option) => (
                          <div>
                            <div>{option.label}</div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {option.data.attributes
                                ?.filter((attr) =>
                                  ["Color", "Karat", "Sizes"].includes(
                                    attr.label
                                  )
                                )
                                ?.map((attr) => `${attr.label}: ${attr.value}`)
                                ?.join(", ")}
                            </div>
                          </div>
                        )}
                        value={selectedVariants.map((variant) => ({
                          value: variant._id,
                          label: `${variant.productName} - ${variant.sku}`,
                          data: variant,
                        }))}
                      />
                    </div>

                    <Row className="gy-4 mb-3">
                      {/* <Col md={6}>
                        <div>
                          <Form.Label htmlFor="createdate-field">
                            Order Date
                          </Form.Label>
                          <Flatpickr
                            className="form-control flatpickr-input"
                            placeholder="Select Date"
                            options={{
                              dateFormat: "d M, Y",
                            }}
                          />
                        </div>
                      </Col> */}
                      {/* <Col md={6}>
                        <div>
                          <Form.Label htmlFor="deliverydate-field">
                            Delivery Date
                          </Form.Label>
                          <Flatpickr
                            className="form-control flatpickr-input"
                            placeholder="Select Date"
                            options={{
                              dateFormat: "d M, Y",
                            }}
                          />
                        </div>
                      </Col> */}
                    </Row>
                    {showCartModal && cart && (
                      <Modal
                        show={showCartModal}
                        onHide={() => setShowCartModal(false)}
                        centered
                        size="lg"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Review Cart & Create Order</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="mb-4">
                            <h5>Customer Information</h5>
                            <div className="mb-3 p-3 bg-light rounded">
                              <Form.Group className="mb-3">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={orderDetails.firstName}
                                  onChange={(e) =>
                                    setOrderDetails({
                                      ...orderDetails,
                                      firstName: e.target.value,
                                    })
                                  }
                                  required
                                />
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={orderDetails.lastName}
                                  onChange={(e) =>
                                    setOrderDetails({
                                      ...orderDetails,
                                      lastName: e.target.value,
                                    })
                                  }
                                  required
                                />
                              </Form.Group>

                              {/* <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                  type="email"
                                  value={
                                    users.find(
                                      (user) => user._id === selectedUserId
                                    )?.email || ""
                                  }
                                  disabled
                                />
                              </Form.Group> */}

                              <Form.Group className="mb-3">
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={orderDetails.phone}
                                  onChange={(e) =>
                                    setOrderDetails({
                                      ...orderDetails,
                                      phone: e.target.value,
                                    })
                                  }
                                  required
                                />
                              </Form.Group>
                            </div>

                            <h5>Shipping Address</h5>
                            <div className="mb-3 p-3 bg-light rounded">
                              <Form.Group className="mb-3">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  value={orderDetails.address}
                                  onChange={(e) =>
                                    setOrderDetails({
                                      ...orderDetails,
                                      address: e.target.value,
                                    })
                                  }
                                  required
                                />
                              </Form.Group>

                              <Row>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={orderDetails.city}
                                      onChange={(e) =>
                                        setOrderDetails({
                                          ...orderDetails,
                                          city: e.target.value,
                                        })
                                      }
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={orderDetails.state}
                                      onChange={(e) =>
                                        setOrderDetails({
                                          ...orderDetails,
                                          state: e.target.value,
                                        })
                                      }
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={orderDetails.country}
                                      onChange={(e) =>
                                        setOrderDetails({
                                          ...orderDetails,
                                          country: e.target.value,
                                        })
                                      }
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>ZIP Code</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={orderDetails.zipCode}
                                      onChange={(e) =>
                                        setOrderDetails({
                                          ...orderDetails,
                                          zipCode: e.target.value,
                                        })
                                      }
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>

                            <h5>Cart Items</h5>
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th style={{ minWidth: "120px" }}>
                                      Product
                                    </th>
                                    <th style={{ minWidth: "100px" }}>
                                      Variant Sku
                                    </th>
                                    <th style={{ minWidth: "120px" }}>
                                      Quantity
                                    </th>
                                    <th style={{ minWidth: "80px" }}>Price</th>
                                    <th style={{ minWidth: "80px" }}>Total</th>
                                    <th style={{ minWidth: "80px" }}>
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {cart.products.map(
                                    (item: any, index: number) => (
                                      <tr key={index}>
                                        <td style={{ minWidth: "120px" }}>
                                          {item.product?.name || "N/A"}
                                        </td>
                                        <td style={{ minWidth: "100px" }}>
                                          {item?.variantSku || "Default"}
                                          {item.variant?.attributes?.map(
                                            (attr: any) => (
                                              <div
                                                key={attr.label}
                                                style={{ fontSize: "0.8em" }}
                                              >
                                                {attr.label}: {attr.value}
                                              </div>
                                            )
                                          )}
                                        </td>
                                        <td style={{ minWidth: "120px" }}>
                                          <div className="d-flex align-items-center">
                                            <Button
                                              variant="outline-secondary"
                                              size="sm"
                                              onClick={() =>
                                                handleDecreaseQuantity(
                                                  item.product._id,
                                                  item.variant
                                                )
                                              }
                                              disabled={isCartLoading}
                                              style={{ minWidth: "30px" }}
                                            >
                                              -
                                            </Button>
                                            <span className="mx-2">
                                              {item.quantity}
                                            </span>
                                            <Button
                                              variant="outline-secondary"
                                              size="sm"
                                              onClick={() =>
                                                handleIncrementQuantity(
                                                  item.product._id,
                                                  item.variant
                                                )
                                              }
                                              disabled={isCartLoading}
                                              style={{ minWidth: "30px" }}
                                            >
                                              +
                                            </Button>
                                          </div>
                                        </td>
                                        <td style={{ minWidth: "80px" }}>
                                          ₹{item.purchasePrice?.toFixed(2)}
                                        </td>
                                        <td style={{ minWidth: "80px" }}>
                                          ₹
                                          {(
                                            item.purchasePrice * item.quantity
                                          ).toFixed(2)}
                                        </td>
                                        <td style={{ minWidth: "80px" }}>
                                          <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() =>
                                              handleDeleteFromCart(
                                                item.product._id,
                                                item.variant
                                              )
                                            }
                                            disabled={isCartLoading}
                                          >
                                            Remove
                                          </Button>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <div className="text-end">
                              <h5>Total: ₹{cart.total?.toFixed(2)}</h5>
                            </div>
                          </div>

                          <Form>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Payment Method</Form.Label>
                                  <Form.Select
                                    value={orderDetails.paymentMethod}
                                    onChange={(e) =>
                                      setOrderDetails({
                                        ...orderDetails,
                                        paymentMethod: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="cash">COD</option>
                                    <option value="card">Online</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Status</Form.Label>
                                  <Form.Select
                                    value={orderDetails.status}
                                    onChange={(e) =>
                                      setOrderDetails({
                                        ...orderDetails,
                                        status: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="Not processed">
                                      Not processed
                                    </option>
                                    <option value="Processing">
                                      Processing
                                    </option>
                                    <option value="Shipped">Shipped</option>
                                    <option value="Delivered">Delivered</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => setShowCartModal(false)}
                          >
                            Cancel
                          </Button>
                          <Button variant="primary" onClick={handleCreateOrder}>
                            Create Order
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {cart && (
                      <Button
                        variant="success"
                        onClick={() =>
                          cart ? setShowCartModal(true) : tog_AddOrderModals()
                        }
                        className="w-100 add-btn"
                      >
                        {cart ? "Review Cart" : ""}
                      </Button>
                    )}
                    {/* <Row className="gy-4 mb-3"> */}
                    {/* <Col md={6}>
                        <div>
                          <Form.Label htmlFor="amount-field">Amount</Form.Label>
                          <Form.Control
                            type="number"
                            id="amount-field"
                            placeholder="Total amount"
                            required
                          />
                        </div>
                      </Col> */}
                    {/* <Col md={6}>
                        <div>
                          <Form.Label htmlFor="payment-field">
                            Payment Method
                          </Form.Label>
                          <div>
                            <select
                              className="form-select"
                              required
                              id="payment-field"
                            >
                              <option value="">Payment Method</option>
                              <option value="Mastercard">Mastercard</option>
                              <option value="Visa">Visa</option>
                              <option value="COD">COD</option>
                              <option value="Paypal">Paypal</option>
                            </select>
                          </div>
                        </div>
                      </Col> */}
                    {/* </Row> */}
                    {/* 
                    <div>
                      <Form.Label htmlFor="delivered-status">
                        Delivery Status
                      </Form.Label>
                      <div>
                        <select
                          className="form-select"
                          required
                          id="delivered-status"
                        >
                          <option value="">Delivery Status</option>
                          <option value="Not processed">Not processed</option>
                          <option value="Processing">Processing</option>
                          <option value="Shipped">Shipped</option>
                          <option value="Delivered">Delivered</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </div>
                    </div> */}
                  </Modal.Body>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <Button
                        // className="btn-ghost-danger"
                        variant="danger"
                        id="close-btn"
                        onClick={() => {
                          tog_AddOrderModals();
                        }}
                      >
                        Close
                      </Button>
                      {/* <Button variant="success" id="add-btn">
                        Add Order
                      </Button> */}
                    </div>
                  </div>
                </Form>
              </Modal>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Quantity Modal */}
      <Modal
        show={showQuantityModal}
        onHide={() => setShowQuantityModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add to Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVariant && (
            <>
              <div className="mb-3">
                <h6>{selectedVariant.product.name}</h6>
                <p className="text-muted mb-2">{selectedVariant.variant.sku}</p>
                <p>
                  {selectedVariant.variant.attributes
                    ?.filter((attr) =>
                      ["Color", "Karat", "Sizes"].includes(attr.label)
                    )
                    ?.map((attr) => `${attr.label}: ${attr.value}`)
                    ?.join(", ")}
                </p>
                <p>Price: ₹{selectedVariant.variant.price?.toFixed(2)}</p>
                <p>Available: {selectedVariant.variant.quantity}</p>
              </div>
              <Form.Group>
                <Form.Label>Quantity</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  max={selectedVariant.variant.quantity}
                  value={quantity}
                  onChange={(e) =>
                    setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                  }
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowQuantityModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddToCart}>
            Add to Order
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default OrdersListView;
